<template>
  <v-container fluid pb-4>
    <v-row>
      <v-col>
        <v-card>
          <v-toolbar :dark="$vuetify.theme.dark" color="primary">
            <v-toolbar-title>
              {{ $t('Управление') }}
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-data-iterator
                :items="blocks"
                hide-default-footer
                disable-pagination
                disable-filtering
                :loading="isLoading"
                item-key="header"
                :locale="systemLocale">
              <template v-slot:header>
                <v-progress-linear :active="isLoading" color="loader" indeterminate />
              </template>
              <template v-slot="props">
                <v-row justify="center">
                  <v-col
                      v-for="block in props.items"
                      :key="block.header"
                      cols="12"
                      sm="12"
                      md="6"
                      lg="5"
                      xl="4">
                    <v-card>
                      <manage-block :item="block" />
                    </v-card>
                  </v-col>
                </v-row>
              </template>
            </v-data-iterator>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ManageBlock from '@/components/reused/common/ManageBlock.vue'
  import { ORG_REQUEST_STATUSES, LOT_REQUEST_TYPES, PROXY_TYPES } from '@/constants/business'
  import { mapActions, mapState } from 'vuex'
  import { STATISTICS } from '@/constants/store.js'

  export default {
    components: {
      ManageBlock
    },
    data () {
      return {
        interval: null,
        isLoading: false
      }
    },
    computed: {
      ...mapState(STATISTICS.NAMESPACE, {
        businessStatistics: state => (state[STATISTICS.STATE.BUSINESS_STATISTICS] || { })
      }),
      blocks () {
        return [
          {
            header: this.$t('Торговые процедуры'),
            icon: 'gavel',
            links: [
              {
                id: 'lotRegistrationRequests',
                name: this.$t('Запросы на регистрацию торговой процедуры'),
                route: `${this.urlRootPath}/tradeRequests/${LOT_REQUEST_TYPES.REGISTRATION}`,
                count: this.businessStatistics.lotRegistration,
                show: true
              },
              {
                id: 'lotSessionRequests',
                name: this.$t('Запросы на повторную сессию'),
                route: `${this.urlRootPath}/tradeRequests/${LOT_REQUEST_TYPES.SESSION_REGISTRATION}`,
                count: this.businessStatistics.sessionRegistrations,
                show: true
              },
              {
                id: 'lotRecallRequests',
                name: this.$t('Запросы на отзыв торговой процедуры'),
                route: `${this.urlRootPath}/tradeRequests/${LOT_REQUEST_TYPES.RECALL}`,
                count: this.businessStatistics.lotRecall,
                show: true
              },
              {
                id: 'lotChangeDocumentsRequests',
                name: this.$t('Запросы на изменение документации по торговой процедуре'),
                route: `${this.urlRootPath}/tradeRequests/${LOT_REQUEST_TYPES.CHANGE_DOCUMENTS}`,
                count: this.businessStatistics.lotChangeDocuments,
                show: true
              },
              {
                id: 'summarizing',
                name: this.$t('Подведение итогов'),
                route: `${this.urlRootPath}/lots/summarizing`,
                count: this.businessStatistics.lotsWithoutTradeResults,
                show: true
              },
              {
                id: 'activeSessions',
                name: this.$t('Активные сессии'),
                route: `${this.urlRootPath}/sessions/active`,
                count: this.businessStatistics.activeSessions,
                show: true
              }
            ]
          },
          {
            header: this.$t('Организации'),
            icon: 'business',
            links: [
              {
                id: 'organizations',
                name: this.$t('Список организаций'),
                route: `${this.urlRootPath}/organizations`,
                show: true
              },
              {
                id: 'organizationsReport',
                name: this.$t('Выгрузка списка организаций'),
                route: `${this.urlRootPath}/reports/organizations`,
                show: true
              }
              // {
              //   id: 'organizationsActivityReport',
              //   name: this.$t('Статистика активности по кварталу'),
              //   route: `${this.urlRootPath}/reports/organizationsActivityReport`,
              //   show: true
              // }
            ]
          },
          {
            header: this.$t('УП организаций'),
            icon: 'people',
            links: [
              {
                id: 'users',
                name: this.$t('Список УП'),
                route: `${this.urlRootPath}/users`,
                show: true
              },
              {
                id: PROXY_TYPES.USER_PROXY,
                name: this.$t('Доверенности УП организаций'),
                route: `${this.urlRootPath}/proxies/${PROXY_TYPES.USER_PROXY}`,
                count: this.businessStatistics.userProxies,
                show: true
              }
            ]
          },
          {
            header: this.$t('Регистрация организаций'),
            icon: 'person',
            links: [
              {
                id: 'organizationRegistration',
                name: this.$t('Запросы на регистрацию организаций'),
                route: `${this.urlRootPath}/organizationRegistrationRequests/${ORG_REQUEST_STATUSES.INPROCESS}`,
                count: this.businessStatistics.organizationRegistration,
                show: true
              },
              {
                id: 'userRegistration',
                name: this.$t('Запросы на регистрацию УП'),
                route: `${this.urlRootPath}/userRegistrationRequests`,
                count: this.businessStatistics.userRegistration,
                show: true
              }
            ]
          }, {
            header: this.$t('Прочее'),
            icon: 'settings_applications',
            links: [
              {
                id: 'mailingLists',
                name: this.$t('Списки рассылок'),
                route: `${this.urlRootPath}/mailingLists`,
                show: true
              },
              {
                id: 'globalMailing',
                name: this.$t('Общая Email рассылка'),
                route: `${this.urlRootPath}/globalMailing`,
                show: true
              },
              {
                id: 'participantsMailing',
                name: this.$t('Адресная Email рассылка'),
                route: `${this.urlRootPath}/participantsMailing`,
                show: true
              },
              {
                id: 'productionCalendar',
                name: this.$t('Производственный календарь'),
                route: `${this.urlRootPath}/productionCalendar`,
                show: true
              },
              {
                id: 'systemSettings',
                name: this.$t('Системные настройки'),
                route: `${this.urlRootPath}/systemSettings`,
                show: true
              },
              {
                id: 'staticPages',
                name: this.$t('Редактируемые страницы'),
                route: `${this.urlRootPath}/staticPages`,
                show: true
              },
              {
                id: 'staticFiles',
                name: this.$t('Файлы общего назначения'),
                route: `${this.urlRootPath}/staticFiles`,
                show: true
              },
              {
                id: 'themes',
                name: this.$t('Настройки темы'),
                route: `${this.urlRootPath}/themes`,
                show: this.isMainAdmin
              },
              {
                id: 'smtpSettings',
                name: this.$t('Настройки SMTP'),
                route: `${this.urlRootPath}/smtpSettings`,
                show: this.isMainAdmin
              },
              {
                id: 'segmentSettings',
                name: this.$t('Настройки сегмента'),
                route: `${this.urlRootPath}/segmentSettings`,
                show: this.isMainAdmin
              }
            ]
          },
          {
            header: this.$t('Сводная информация'),
            icon: 'table_chart',
            links: [
              {
                id: 'lotCommissionReport',
                name: this.$t('Комиссия по итогам торговых процедур'),
                route: `${this.urlRootPath}/reports/lotCommission`,
                show: true
              },
              {
                id: 'lotsStatisticsReport',
                name: this.$t('Статистика по итогам торговых процедур'),
                route: `${this.urlRootPath}/reports/lots/statistics`,
                show: true
              },
              {
                id: 'bankAccounts',
                name: this.$t('Реестр банковских реквизитов пользователей'),
                route: `${this.urlRootPath}/reports/bankAccounts`,
                show: true
              }
            ]
          }
        ]
      }
    },
    beforeDestroy () {
      if (this.interval) {
        clearInterval(this.interval)
      }
    },
    created () {
      const vm = this
      vm.clearStore().then(() => {
        vm.getStatistics()
        // каждые 5 минут запрашиваем статистику
        if (!vm.interval) {
          vm.interval = setInterval(() => {
            vm.getStatistics()
          }, 300000)
        }
      })
    },
    methods: {
      ...mapActions(STATISTICS.NAMESPACE, {
        getBusinessStatisticsAction: STATISTICS.ACTIONS.GET_BUSINESS_STATISTICS,
        clearBusinessStatisticsAction: STATISTICS.ACTIONS.CLEAR_BUSINESS_STATISTICS
      }),
      clearStore: async function () {
        await Promise.all([
          this.clearBusinessStatisticsAction()
        ])
      },
      getStatistics: async function () {
        try {
          this.isLoading = true
          await Promise.all([
            this.getBusinessStatisticsAction()
          ])
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      }
    }
  }
</script>
